module.exports = __webpack_public_path__ + "img/icon_t19.0e4b4c77.png";